define('SC.HorizonThemeExtension.Footer.Simplified', [
  'underscore',
  'SC.HorizonThemeExtension.Common.Configuration',
  'SC.HorizonThemeExtension.Common.LayoutHelper'
], function ThemeExtensionFooterSimplified(_, Configuration, LayoutHelper) {
  'use strict';

  return {
    loadModule: function loadModule() {
      // for Copyright message
      var initialConfigYear = Configuration.get('footer.copyright.initialYear');
      var initialYear = initialConfigYear
        ? parseInt(initialConfigYear, 10)
        : new Date().getFullYear();
      var currentYear = new Date().getFullYear();

      LayoutHelper.addToViewContextDefinition(
        'Footer.Simplified.View',
        'extraFooterSimplifiedView',
        'object',
        function () {
          return {
            backgroundUrl: Configuration.get('footer.backgroundImg'),
            copyright: {
              hide: !!Configuration.get('footer.copyright.hide'),
              companyName: Configuration.get('footer.copyright.companyName'),
              initialYear: initialYear,
              currentYear: currentYear,
              showRange: initialYear < currentYear
            },
            text: Configuration.get('footer.text')
          };
        }
      );
    }
  };
});
